package fr.frux.feature.map

import fr.frux.core.common.logging.Logger
import fr.frux.feature.map.resources.Res
import kotlinx.coroutines.CancellationException

/**
 * Instantane prod de la pyramide embarque dans l'app (#622), rafraichi par la tache Gradle
 * `refreshEmbeddedClusterPyramid`. Null s'il est illisible : le repository attend alors le reseau.
 */
internal suspend fun readEmbeddedClusterPyramid(): String? =
    runCatching { Res.readBytes("files/cluster-pyramid.json").decodeToString() }
        .onFailure {
            if (it is CancellationException) throw it
            Logger.e("EmbeddedClusterPyramid", "Instantane embarque illisible", it)
        }.getOrNull()

/**
 * Lecture de l'instantane, substituable en test. Interface plutot que `suspend () -> String?` : Metro
 * refuse un type fonctionnel suspendu en parametre d'un constructeur `@Inject`.
 */
fun interface EmbeddedPyramidSource {
    suspend fun read(): String?
}
